import { AuthMethodType } from '@lit-protocol/constants';
import { useState } from 'react';
import { MdOutlineMail } from 'react-icons/md';
import { FaPhoneVolume } from 'react-icons/fa6';
import { FaWhatsapp } from 'react-icons/fa';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { StytchFactorOtp } from '@/components/auth/stytchFactorOtp';
import { Button } from '../ui/button';
import SlidingModal from '../home/mobile/SlidingModal';
import useMFAUtilities from '@/hooks/LitSessionContext/useMFAUtilities';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
export default function MfaAuthData({
  MFAInfo
}) {
  const [openModalIndex, setOpenModalIndex] = useState<number | null>(null);
  const isMobile = useIsMobile();
  const {
    ToggleMFA
  } = useMFAUtilities();
  const IconClass = 'h-[20px] w-[20px] text-genius-pink';
  const mfaAuthData = [{
    title: 'Email',
    authMethodType: AuthMethodType.StytchEmailFactorOtp,
    status: MFAInfo?.authMethod?.authMethodType == AuthMethodType.StytchEmailFactorOtp ? 'Synced' : 'Add as an Additional Login Method',
    kind: MFAInfo?.authMethod?.authMethodType == AuthMethodType.StytchEmailFactorOtp ? '' : MFAInfo?.authMethod ? 'wait' : 'connect',
    className: MFAInfo?.authMethod?.authMethodType == AuthMethodType.StytchEmailFactorOtp ? 'text-genius-pink' : 'text-genius-cream',
    icon: <MdOutlineMail className={IconClass} />
  }, {
    title: 'Text Message',
    authMethodType: AuthMethodType.StytchSmsFactorOtp,
    status: MFAInfo?.authMethod?.authMethodType == AuthMethodType.StytchSmsFactorOtp ? 'Synced' : 'Add as an Additional Login Method',
    kind: MFAInfo?.authMethod?.authMethodType == AuthMethodType.StytchSmsFactorOtp ? '' : MFAInfo?.authMethod ? 'wait' : 'connect',
    className: MFAInfo?.authMethod?.authMethodType == AuthMethodType.StytchSmsFactorOtp ? 'text-genius-pink' : 'text-genius-cream',
    icon: <FaPhoneVolume className={`h-[16.5px] w-[16.5px] text-genius-pink`} />
  }, {
    title: 'WhatsApp',
    authMethodType: AuthMethodType.StytchWhatsAppFactorOtp,
    status: MFAInfo?.authMethod?.authMethodType == AuthMethodType.StytchWhatsAppFactorOtp ? 'Synced' : 'Add as an Additional Login Method',
    kind: MFAInfo?.authMethod?.authMethodType == AuthMethodType.StytchWhatsAppFactorOtp ? '' : MFAInfo?.authMethod ? 'wait' : 'connect',
    className: MFAInfo?.authMethod?.authMethodType == AuthMethodType.StytchWhatsAppFactorOtp ? 'text-genius-pink' : 'text-genius-cream',
    icon: <FaWhatsapp className={`h-[21px] w-[21px] text-genius-pink`} />
  }];
  const hasSyncedItem = mfaAuthData.some(item => item.status === 'Synced');
  const toggleModal = (index: number) => {
    setOpenModalIndex(index === openModalIndex ? null : index);
  };
  return <>
      {mfaAuthData.map((infoItem, index) => {
      return <div className={`flex py-4 pl-4 pr-0 items-center w-full`} key={index}>
            <div className={`flex w-full ${infoItem.status !== 'Synced' && hasSyncedItem ? 'opacity-50' : ''}`}>
              <div className='flex items-center gap-x-2 w-1/6'>{infoItem.icon}</div>
              <div className='flex items-center gap-x-2 w-5/6'>
                <div className='flex flex-col gap-y-[2px]'>
                  <p className='text-base/4 text-genius-cream'>{infoItem.title}</p>
                  <p className='text-genius-cream/50 text-xs/3'>
                    <span>
                      {infoItem.status === 'Synced' ? <span className='text-green-400'>
                          Synced:{' '}
                          <span className='text-genius-cream/50'>{MFAInfo.providerValue}</span>
                        </span> : 'Add an additional login method'}
                    </span>
                  </p>
                </div>
              </div>
              <div onClick={() => {
            if (infoItem.kind === 'wait') {
              return;
            }
            toggleModal(index);
          }} className='control flex flex-col w-2/6 pr-2'>
                {infoItem.kind === '' && <Button onClick={() => toggleModal(index)} className='rounded-full bg-genius-blue md:hover:bg-genius-blue text-genius-cream w-[100px] h-8'>
                    Disconnect
                  </Button>}
                {infoItem.kind === 'connect' && <Button onClick={() => {
              if (infoItem.status !== 'Synced' && hasSyncedItem) return;
              toggleModal(index);
            }} className='rounded-full bg-genius-blue md:hover:bg-genius-blue text-genius-cream w-[90px] h-8'>
                    Connect
                  </Button>}
                {infoItem.kind === 'wait' && <Button onClick={() => {
              if (infoItem.status !== 'Synced' && hasSyncedItem) return;
              toggleModal(index);
            }} className='rounded-full bg-genius-blue md:hover:bg-genius-blue text-genius-cream w-[90px] h-8'>
                    Connect
                  </Button>}
              </div>
            </div>
            {isMobile ? <SlidingModal heightFit isOpen={openModalIndex === index} onClose={() => toggleModal(index)}>
                <div className='pt-2 px-2 pb-2 flex flex-col items-center justify-center gap-y-4'>
                  <div className='flex gap-x-4 items-center  w-full px-6'></div>
                  <StytchFactorOtp title={infoItem.title} authMethodType={infoItem.authMethodType} pastAuthMethod={infoItem?.status} callBack={ToggleMFA} closeDialog={() => toggleModal(index)} />
                </div>
              </SlidingModal> : <Dialog open={openModalIndex === index} onOpenChange={() => {
          toggleModal(index);
        }}>
                <DialogContent className='max-lg:max-w-sm max-w-3xl bg-genius-indigo text-genius-cream text-sm text-center'>
                  <div className='pt-8 px-2 pb-2 flex flex-col items-center justify-center gap-y-4'>
                    <div className='flex gap-x-4 items-center'>
                      <div className='flex flex-col gap-y-[2px]'>
                        <p className='text-md text-genius-cream'>{infoItem.title}</p>
                      </div>
                    </div>
                    <StytchFactorOtp title={infoItem.title} authMethodType={infoItem.authMethodType} pastAuthMethod={MFAInfo?.authMethod} callBack={ToggleMFA} closeDialog={() => toggleModal(index)} />
                  </div>
                </DialogContent>
              </Dialog>}
          </div>;
    })}
    </>;
}